import Button from "../Input/Button";
import * as Icon from "react-bootstrap-icons";

export default function Pagination({
  currentPage,
  perPage,
  numItems,
  paginate,
}) {
  const pages = Math.ceil(numItems / perPage);

  var pageNums = [];

  for (let i = 1; i <= pages; i++) {
    pageNums.push(i);
  }

  return (
    <>
      <div className="col">
          {pages > 0 && numItems > 0 &&
              <p className="pagination-detail">
                  Page {currentPage} of {pages} ({numItems} Items)
              </p>
          }
          {pages === 0 && numItems === 0 &&
              <p>
                  No Records Found
              </p>
          }
      </div>
      <div className="col">
        <div className="pagination-selector">
          <Button
            className="btn btn--white"
            icon={<Icon.ChevronLeft color="" />}
            onClick={() => {
              if (currentPage > 1) paginate(currentPage - 1);
            }}
          />
          {pageNums.map((num, key) => {
            return (
              <Button
                className={`btn ${
                  currentPage === num ? "btn--white--highlight" : ""
                } btn--white`}
                text={num}
                key={key}
                onClick={() => {
                  paginate(num);
                }}
              />
            );
          })}
          <Button
            className="btn btn--white"
            icon={<Icon.ChevronRight color="" />}
            onClick={() => {
              if (currentPage < pages) paginate(currentPage + 1);
            }}
          />
        </div>
      </div>
    </>
  );
}
